import makeStyles from '@mui/styles/makeStyles';

const useTimeZoneSelectStyles = makeStyles({
  root: {}
});

export default useTimeZoneSelectStyles;
